import {StyleSheet} from 'react-native';

import {cloudLight, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
  },
  content: {
    flex: 1,
    backgroundColor: white,
  },
  loading: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
